<template>
  <v-container v-if="account">
    <v-row>
      <v-col>
        <v-alert v-if="error" color="red" type="warning">{{ error }}</v-alert>
        <div class="flex">
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title
                >{{ account.first_name }}
                {{ account.last_name }}</v-toolbar-title
              >
            </v-toolbar>
            <v-card-text>
              {{ account.email }}
              <h4>Permissions</h4>
              <v-chip-group active-class="primary--text" column>
                <v-chip :color="account.permission_admin ? 'primary' : 'red'">
                  Admin </v-chip
                ><v-chip :color="account.permission_login ? 'primary' : 'red'">
                  Login
                </v-chip>
                <v-chip
                  :color="account.permission_updateOthers ? 'primary' : 'red'"
                >
                  Update Others
                </v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Update Password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="password"
              label="Password"
              v-model="password"
              hint="At least 8 characters"
              @click:append="show = !show"
            ></v-text-field>
            <v-text-field
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="password"
              label="Confirm Password"
              v-model="confirmPassword"
              hint="At least 8 characters"
              @click:append="show = !show"
            ></v-text-field>
            <v-btn color="primary" @click="updatePassword()">Update</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  data() {
    return {
      account: null,
      show: false,
      error: null,
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    getAccount() {
      axios.get("/api/v1/user/me").then((res) => {
        this.account = res.data;
      });
    },
    updatePassword() {
      if (this.password !== this.confirmPassword) {
        this.error = "Passwords do not match";
        return;
      }
      let that = this;
      axios
        .post("/api/v1/user/update-password", {
          password: that.password,
          email: that.account.email,
        })
        .then(() => {
          that.error = null;
          //Refresh page
          window.location.reload();
        })
        .catch((err) => {
          that.error = err.response.data;
        });
    },
  },
  created() {
    this.getAccount();
  },
};
</script>

<style lang="scss" scoped></style>
